module.exports = __webpack_public_path__ + "img/share.49c20890.svg";